import { ResolverTag } from '@ps/web-core-enums';
import { CrossPlatformLink, useResolver } from '@ps/web-shared-components';
import React from 'react';

import CMSHTML from '../../../../../CMSHTML/CMSHTML';
import CMSImage from '../../../../../CMSImage/CMSImage';
import type { Props } from '../../TopHeader';

import styles from './RegulatoryHeaderPA.scss';

const RegulatoryHeaderPA: React.FC<Props> = ({ regulatory_header: [{ texts, icons }] }) => {
  const helpResponsibleGaming = useResolver(ResolverTag.HelpResponsibleGaming);

  return (
    <>
      <div className={styles.partnership}>
        <div className={styles.regulatoryText}>
          <CMSHTML content={texts[0].content} />
        </div>
        <CMSImage {...icons[0]} />
      </div>
      <div className={styles.responsibleGaming}>
        <div className={styles.regulatoryText}>
          <CMSHTML content={texts[1].content} />
        </div>
        <CrossPlatformLink className={styles.responsibleGamingLinks} href={helpResponsibleGaming}>
          <CMSImage {...icons[1]} />
          <CMSHTML content={texts[2].content} />
        </CrossPlatformLink>
      </div>
    </>
  );
};

export default RegulatoryHeaderPA;
